import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { type PropsWithChildren } from "react";
import Picture from "@/components/common/Picture";
import type { ExtendedUploadedImage } from "@/types";
import s from "./Thumbnail.module.scss";

export interface ThumbnailProps {
  thumbnail: ExtendedUploadedImage;
}

export default function Thumbnail(props: PropsWithChildren<ThumbnailProps>) {
  const { thumbnail, children } = props;

  if (!thumbnail.source?.path && !children) {
    return null;
  }

  return (
    <div className={s.wrapper}>
      <div className={s.thumbnail}>
        <Picture imageConfig={thumbnail} />
        <div className={s.icon}>
          <FileDownloadIcon />
        </div>
      </div>
      <div className={s.title}>{children}</div>
    </div>
  );
}
